





































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {$, error, ID, PageCollection, pushByName, success, WholeCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import EmailAuditoriaEnvio from '@/model/resource/EmailAuditoriaEnvio'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import EmailNivel from '@/model/resource/EmailNivel'
import EmailAuditoria from '@/model/resource/EmailAuditoria'

const metaInfo = () => ({
  title: $.t('classes.EmailAuditoriaEnvio.title'),
})

@Component({
  metaInfo,
})
export default class ManageAwaitingAuditCorrectionListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/responsavel') user!: Responsavel

  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(EmailAuditoriaEnvio, {}, 10)

  emailAuditoria = new EmailAuditoria()
  selectedItems: EmailAuditoriaEnvio[] = []
  selecting = false // notify only selected or notify all
  notifyOpen = false

  allEmailNivel = new WholeCollection(EmailNivel)
  allAuditoriaEmail = new WholeCollection(EmailAuditoria)

  async downloadData(xlsx = false) {
    if (!xlsx) {
      const csv = new PageCollection(EmailAuditoriaEnvio, {}, null, null)

      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv(snakeCase($.t('classes.EmailAuditoriaEnvio.title')))
    } else {
      await $.await.run(() => Helper.downloadXlsx(
          $.t('classes.EmailAuditoriaEnvio.title'),
          new EmailAuditoriaEnvio().$endpoint,
          this.filter,
          EmailAuditoriaEnvio,
          'EmailAuditoriaEnvio',
      ), 'download')
    }
  }

  emailNotifyList() {
    this.selecting = true
    this.notifyOpen = true
  }

  emailNotifyAll() {
    this.selecting = false
    this.notifyOpen = true
    this.selectedResource = {}
  }

  cancelSendEmail() {
    this.selecting = false
    this.notifyOpen = false
    this.selectedResource = {}
  }

  get emailResource() {
    return this.emailAuditoria
  }

  set emailResource(val: EmailAuditoria) {
      this.emailAuditoria = val
  }

  get emailNivel() {
    return this.emailAuditoria &&
    this.emailAuditoria.emailAuditoriaNivel && this.emailAuditoria.emailAuditoriaNivel.emailNivel ?
        this.emailAuditoria.emailAuditoriaNivel.emailNivel : new EmailNivel()
  }

  set emailNivel(val: EmailNivel) {
    if (this.emailAuditoria && this.emailAuditoria.emailAuditoriaNivel
        && this.emailAuditoria.emailAuditoriaNivel.emailNivel) {
      this.emailAuditoria.emailAuditoriaNivel.emailNivel = val
    }
  }

  @Watch('emailAuditoria', {deep: true})
  async populateNivel() {
    if (this.emailResource) {
      this.$await.init('getNivel')
      this.allEmailNivel.endpoint = `/user/email-auditoria/grupo-nivel/${this.emailResource.idEmailAuditoriaPk}`
      await this.allEmailNivel.query()
      this.$await.done('getNivel')
    }
  }

  async mounted() {
    this.allAuditoriaEmail.endpoint = `/user/email-auditoria/active-grupos/${this.user.$id}`
    await this.allAuditoriaEmail.query()
  }

  async sendEmails() {
    if (this.collection.items.length === 0) {
      error('classes.EmailAuditoriaEnvio.noCargaSelected')
      return
    }
    let idCargas: ID[] = []
    let allTiers = false
    if (this.selecting) {
      if (!this.selectedItems.length) {
        error('classes.EmailAuditoriaEnvio.noCargaSelected')
        return
      }
      idCargas = this.selectedItems.map((item) => {
        return item.idCargaFk
      })
    }

    if (this.emailResource.idEmailAuditoriaPk === 0) {
      error('classes.EmailAuditoriaEnvio.noGroupSelected')
      return
    }

    if (this.emailResource.emailAuditoriaNivel.emailNivel.idEmailNivelPk === 0) {
      allTiers = true
    }

    await EmailAuditoria.sendAuditoriaEmail(idCargas, this.emailResource, !this.selecting, allTiers)
    success('classes.EmailAuditoriaEnvio.successOnNotify')
    this.cancelSendEmail()
  }
}
